import { NextRouter } from 'next/router'

export const makePageUrl = (page: number, route: NextRouter) => {
  const [path, queryParams] = route.asPath.split('?')

  const searchParams = new URLSearchParams(queryParams)
  searchParams.delete('pagina')

  if (page > 1) {
    searchParams.set('pagina', page.toString())
  }

  if (searchParams.size > 0) {
    const decodeURI = decodeURIComponent(`${path}?${searchParams.toString()}`)
    return decodeURI
  }

  return path
}
